import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { SetupWizardComponent } from './setup-wizard/setup-wizard.component';
import { ProjectConfigOverviewComponent } from './project-config-overview/project-config-overview.component';
import { ConfigService } from '../../../../services/config.service';
import { AppGlobals } from '../../../../app.globals';

@Component({
    selector: 'app-project-structure-config',
    imports: [CommonModule, SetupWizardComponent, ProjectConfigOverviewComponent],
    templateUrl: './project-structure-config.component.html',
    styleUrl: './project-structure-config.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectStructureConfigComponent {
  isConfigured = null;
  isLoading = true;

  constructor(
    private configService: ConfigService,
    private cdr: ChangeDetectorRef
  ) {
    this.getConfigState();
  }

  async getConfigState() {
    this.isLoading = true;
    try {
      const result = await this.configService.getProjectConfigStatus({});
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
        this.isConfigured = result.hasProjectConfiguration;
      }
    } catch (error) {
      AppGlobals.ShowErrorMessage(error);
    }
    this.isLoading = false;
    this.cdr.detectChanges();
  }

  onSetupComplete() {
    this.getConfigState();
  }

  onSetupCancel() {
    this.isConfigured = false;
    this.cdr.markForCheck();
    this.configService.emitSetupCancel();
  }
}
